import { render } from "./PropertyMarketingMaterials.vue?vue&type=template&id=1a955b3a&scoped=true"
import script from "./PropertyMarketingMaterials.vue?vue&type=script&lang=js"
export * from "./PropertyMarketingMaterials.vue?vue&type=script&lang=js"

import "./PropertyMarketingMaterials.vue?vue&type=style&index=0&id=1a955b3a&scoped=true&lang=css"
import "./PropertyMarketingMaterials.vue?vue&type=style&index=1&id=1a955b3a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a955b3a"]])

export default __exports__